export const teamManagement = {
  forbidden: {
    title: "Accès restreint",
    desc: "Seul l'hôte principal peut gérer l'équipe.",
  },
  header: {
    title: "Gestion de l'équipe",
    subtitle: "Gérez qui peut accéder au tableau de bord de votre propriété",
    addMember: "Ajouter un membre",
  },
  stats: {
    totalTeam: "Équipe totale",
    host: "Hôte",
    additionalMembers: "Membres supplémentaires",
  },
  search: {
    placeholder: "Rechercher par nom ou e-mail…",
  },
  loading: "Chargement de l'équipe…",
  table: {
    member: "Membre",
    email: "E-mail",
    role: "Rôle",
    properties: "Propriétés",
    added: "Ajouté",
    actions: "Actions",
    ownerBadge: "Hôte",
    mainHost: "Hôte principal",
    viewPermissions: "Voir les fonctionnalités autorisées",
    allProperties: "Toutes",
    unassigned: "Non attribué",
    notEditable: "Non modifiable",
    edit: "Modifier",
    delete: "Supprimer",
  },
  surfaces: {
    web: "Web",
    app: "App",
  },
  empty: {
    title: "Aucun membre supplémentaire",
    desc: "Utilisez le bouton <strong>Ajouter un membre</strong> pour inviter des personnes dans votre équipe.",
  },
  infoBanner:
    "Les membres de l'équipe accèdent au tableau de bord avec leur propre identifiant et mot de passe. Chaque profil a des autorisations fixes et l'accès aux données est appliqué sur le serveur. Le propriétaire se connecte uniquement via le web ; le ménage et la maintenance, uniquement via l'app. L'<strong>hôte principal</strong> dispose toujours d'un accès complet et ne peut pas être supprimé.",
  modal: {
    createTitle: "Ajouter un membre",
    editTitle: "Modifier le membre",
    nameLabel: "Nom complet",
    namePlaceholder: "ex. Maria Garcia",
    emailLabel: "Adresse e-mail",
    emailPlaceholder: "email@example.com",
    roleLabel: "Profil d'accès",
    viewScope: "Périmètre de vue",
    accessIncluded: "Accès inclus",
    assignedProperties: "Propriétés attribuées",
    selectedCount: "({selected} sur {total} sélectionnées)",
    propertySearchPlaceholder: "Rechercher une propriété…",
    selectAll: "Tout sélectionner",
    clear: "Effacer",
    noResults: 'Aucun résultat pour "{query}"',
    selectAtLeastOneHint: "Sélectionnez au moins une propriété pour ce profil.",
    noPropertiesWarning:
      "Aucune propriété n'est disponible à attribuer. Créez une propriété avant d'enregistrer ce profil.",
    passwordLabel: "Mot de passe",
    passwordOptional: "(laisser vide pour ne pas modifier)",
    passwordPlaceholder: "Au moins 8 caractères",
    confirmPasswordLabel: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Répétez le mot de passe",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    cancel: "Annuler",
    create: "Créer le membre",
    save: "Enregistrer les modifications",
  },
  deleteModal: {
    title: "Supprimer le membre",
    subtitle: "Cette action est irréversible",
    confirm:
      "Êtes-vous sûr de vouloir retirer {name} de l'équipe ? Il perdra immédiatement l'accès au tableau de bord.",
    cancel: "Annuler",
    delete: "Supprimer",
  },
  roleInfo: {
    defaultTitle: "Autorisations",
    description:
      "Ce profil est fixe. Son périmètre, sa surface d'accès et ses propriétés sont également validés sur le serveur.",
    understood: "Compris",
  },
  roleDescriptions: {
    anfitrion: "Accès complet à toutes les propriétés depuis le web et l'app.",
    propietario:
      "Calendriers et statistiques pour les propriétés attribuées uniquement. Accès web.",
    limpieza:
      "Démarrage du ménage, tâches et messages pour leurs propriétés. App uniquement.",
    mantenimiento:
      "Démarrage de la maintenance, tâches et messages pour leurs propriétés. App uniquement.",
    fallback: "Profil de compatibilité avec accès restreint.",
  },
  optionalHints: {
    messages:
      "Voir et répondre aux conversations de leurs propriétés. Si désactivé, ils ne verront pas les messages ni ne recevront leurs notifications.",
  },
  toasts: {
    loadError: "Impossible de charger l'équipe.",
    memberAdded: "✓ Membre ajouté à l'équipe.",
    memberUpdated: "✓ Membre mis à jour.",
    saveError: "Impossible d'enregistrer. Veuillez réessayer.",
    memberDeleted: "Membre retiré de l'équipe.",
    deleteError: "Impossible de retirer le membre.",
  },
};
